import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-smartlabel-selector',
  templateUrl: './smartlabel-selector.component.html',
  styleUrls: ['./smartlabel-selector.component.scss']
})
export class SmartlabelSelectorComponent implements OnInit {
  @Input() config: {[key: string]: any} = {};
  @Output() optionChange = new EventEmitter();
  preSelectedIndex: number = 0;
  mode: 'ios' | 'md' = 'md';
  interface = 'popover';
  interfaceOptions = {};
  constructor() { }

  ngOnInit() {
    // console.log('config', this.config);
    this.preSelectedIndex = this.config.preSelectedIndex || 0;
    if (this.config.mode === 'ios' || this.config.mode === 'md') {
      this.mode = this.config.mode;
    }
    if (this.config.interfaceOptions) {
      this.interfaceOptions = this.config.interfaceOptions;
    }
  }


  /**
   * onOptionChange - Emits output event whenever value is selected from dropdown
   * @param event - native event
   * @task - QLIKTAG3597
   * @author - SwapnilP
   */
  onOptionChange(event: CustomEvent) {
    // console.log('Smartlabel Selector Component', event);
    this.optionChange.emit({type: 'smartlabel-selector', payload: { value: event.detail.value, type: this.config.type }});
  }
}
